import Button from './Button';
import variants from './variants';

export default Button;
export {
  variants,
};
